import {
  Box, Checkbox, Chip, Dialog, DialogContent, DialogTitle, Divider,
  IconButton, Stack, Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { momentLabel, STATUS, timeLabel } from "../taskUi";
import { taskDialogPaperSx } from "./TaskVisualShell";

export default function TaskDetailDialog({ task, onClose }) {
  if (!task) return null;
  const status = STATUS[task.status] ?? { label: task.status, color: "default" };
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm" aria-labelledby="task-detail-title" PaperProps={{ sx: taskDialogPaperSx }}>
      <DialogTitle id="task-detail-title" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.5 }}>
        <Typography component="span" sx={{ fontSize: 20, fontWeight: 700, color: "primary.800" }}>{task.title}</Typography>
        <IconButton size="small" onClick={onClose} aria-label="Cerrar detalle"><CloseIcon fontSize="small" /></IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ px: 2.5, py: 2 }}>
        <Stack spacing={1.5}>
          <Stack direction="row" gap={1} flexWrap="wrap">
            <Chip label={status.label} color={status.color} size="small" />
            <Chip label={task.roleName || "Tarea individual"} variant="outlined" size="small" />
            <Chip label={momentLabel(task.moment)} variant="outlined" size="small" />
          </Stack>
          <Box sx={{ p: 1.5, bgcolor: "neutral.50", border: "1px solid", borderColor: "neutral.200", borderRadius: "12px" }}>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: "neutral.600", textTransform: "uppercase" }}>Empleado</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 800, color: "primary.900" }}>{task.employeeName}</Typography>
          </Box>
          {task.description ? <Typography sx={{ whiteSpace: "pre-wrap" }}>{task.description}</Typography> : null}
          {(task.targetTime || task.estimatedMinutes) ? (
            <Stack direction="row" gap={2} alignItems="center" color="text.secondary">
              <AccessTimeIcon fontSize="small" />
              {task.targetTime ? <Typography variant="body2">Hora objetivo: {timeLabel(task.targetTime)}</Typography> : null}
              {task.estimatedMinutes ? <Typography variant="body2">Duración: {task.estimatedMinutes} min</Typography> : null}
            </Stack>
          ) : null}
          {task.checklist?.length ? (
            <>
              <Divider />
              <Box sx={{ p: 1.5, bgcolor: "neutral.50", borderRadius: "12px" }}>
                <Typography sx={{ fontSize: 14, fontWeight: 800, color: "primary.900", mb: 0.5 }}>Checklist</Typography>
                {task.checklist.map((step) => (
                  <Stack key={step.id} direction="row" alignItems="center">
                    <Checkbox checked={Boolean(step.completed)} disabled />
                    <Typography sx={{ textDecoration: step.completed ? "line-through" : "none" }}>{step.title}</Typography>
                  </Stack>
                ))}
              </Box>
            </>
          ) : null}
          <Typography variant="caption" color="text.secondary">
            Vista de sólo lectura. Los estados se actualizan desde la jornada del empleado.
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
